/**
 * OrderConsolidation Component
 *
 * This component has been completely refactored to use the new
 * IndentConsolidationDashboard which implements the updated business logic
 * for consolidating branch indents and placing central orders.
 *
 * The new dashboard provides:
 * - Central Indent Consolidation interface
 * - Area and date-based filtering
 * - Multi-select indent capability
 * - Real-time consolidated item summary
 * - CSV export functionality
 * - Order confirmation dialog
 * - Professional, compact design (12-14px font)
 * - Primary color: #004D00
 *
 * @component
 * @returns {JSX.Element} Indent Consolidation Dashboard
 */

import IndentConsolidationDashboard from './IndentConsolidationDashboard';

export const OrderConsolidation = () => {
  return <IndentConsolidationDashboard />;
};

export default OrderConsolidation;
